/*
 * JUMO cart behaviour (README §6) — progressive enhancement.
 * - Single add-to-cart from product cards ([data-jumo-add]).
 * - Quick order: collect SKU rows, resolve via predictive search, add in one request.
 * - CSV upload stub (sku,qty per line).
 * - Live header count badge ([data-cart-count]) + top-center toast.
 * Works without this file (links/forms degrade gracefully); does nothing if JS off.
 */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function url(path) {
    return ROOT.replace(/\/$/, '') + path;
  }

  // ---- Localized strings ----
  var STRINGS = {
    added: 'Added to cart',
    added_quick: '%{count} item(s) added to cart',
    error: 'Could not be added to cart',
    empty_quick: 'Please enter at least one article number',
    not_found: 'Not found: %{skus}',
    loading: 'Adding …'
  };
  try {
    var cfg = document.querySelector('[data-jumo-cart-strings]');
    if (cfg) {
      STRINGS = Object.assign(STRINGS, JSON.parse(cfg.textContent));
    }
  } catch (e) {
    /* keep defaults */
  }
  function format(template, vars) {
    return String(template).replace(/\[(\w+)\]/g, function (_, key) {
      return vars && vars[key] != null ? vars[key] : '';
    });
  }

  // ---- Toast (top-center, ~200ms in, auto-dismiss) ----
  var toastTimer;
  function ensureToastHost() {
    var host = document.querySelector('.jumo-toast-host');
    if (!host) {
      host = document.createElement('div');
      host.className = 'jumo-toast-host';
      host.setAttribute('role', 'status');
      host.setAttribute('aria-live', 'polite');
      document.body.appendChild(host);
    }
    return host;
  }
  function toast(message, isError) {
    var host = ensureToastHost();
    host.innerHTML = '';
    var el = document.createElement('div');
    el.className = 'jumo-toast' + (isError ? ' jumo-toast--error' : '');
    el.textContent = message;
    host.appendChild(el);
    // trigger transition
    requestAnimationFrame(function () {
      el.classList.add('is-visible');
    });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () {
        if (el.parentNode) el.parentNode.removeChild(el);
      }, 220);
    }, 2600);
  }

  // ---- Cart count badge ----
  function setCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', count <= 0);
    });
  }
  function refreshCount() {
    return fetch(url('/cart.js'), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCount(cart.item_count); return cart; })
      .catch(function () {});
  }

  // ---- Add to cart ----
  function addItems(items) {
    return fetch(url('/cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw data;
        return data;
      });
    });
  }

  function setBusy(el, busy) {
    if (!el) return;
    if (busy) {
      el.setAttribute('aria-busy', 'true');
      el.setAttribute('aria-disabled', 'true');
    } else {
      el.removeAttribute('aria-busy');
      el.removeAttribute('aria-disabled');
    }
  }

  // ---- Single add (product cards) ----
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-jumo-add]');
    if (!btn) return;
    event.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    // Menge: explizites Attribut hat Vorrang, sonst Stepper-Input der Karte.
    var qty = parseInt(btn.getAttribute('data-quantity'), 10);
    if (!qty) {
      var card = btn.closest('.jumo-product-card');
      var qtyInput = card && card.querySelector('[data-quantity-input]');
      if (qtyInput) qty = parseInt(qtyInput.value, 10);
    }
    if (!qty || qty < 1) qty = 1;
    setBusy(btn, true);
    addItems([{ id: id, quantity: qty }])
      .then(function () {
        return refreshCount();
      })
      .then(function () {
        toast(STRINGS.added);
      })
      .catch(function (err) {
        toast((err && err.description) || STRINGS.error, true);
      })
      .finally(function () {
        setBusy(btn, false);
      });
  });

  // ---- Quick order ----
  function resolveSku(sku) {
    var q = url('/search/suggest.json') +
      '?q=' + encodeURIComponent(sku) +
      '&resources[type]=product' +
      '&resources[limit]=5' +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=variants.sku,title,product_type,vendor';
    return fetch(q, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        var wanted = sku.trim().toLowerCase();
        for (var i = 0; i < products.length; i++) {
          var variants = products[i].variants || [];
          // Prefer an exact SKU match when the API returns it.
          for (var j = 0; j < variants.length; j++) {
            if (variants[j].sku && String(variants[j].sku).toLowerCase() === wanted) {
              return variants[j].id;
            }
          }
        }
        // Best-effort fallback: first variant of the first match.
        if (products[0] && products[0].variants && products[0].variants[0]) {
          return products[0].variants[0].id;
        }
        return null;
      })
      .catch(function () { return null; });
  }

  function readRows(scope) {
    var rows = [];
    scope.querySelectorAll('.jumo-quick__row').forEach(function (row) {
      var skuEl = row.querySelector('.jumo-field__input');
      var qtyEl = row.querySelector('.jumo-stepper__input');
      var sku = skuEl && skuEl.value ? skuEl.value.trim() : '';
      if (!sku) return;
      var qty = qtyEl ? parseInt(qtyEl.value, 10) : 1;
      if (!qty || qty < 1) qty = 1;
      rows.push({ sku: sku, quantity: qty });
    });
    return rows;
  }

  function feedback(scope, message, state) {
    var el = scope.querySelector('[data-quick-order-feedback]');
    if (!el) return;
    el.textContent = message;
    el.hidden = !message;
    if (state) {
      el.setAttribute('data-state', state);
    } else {
      el.removeAttribute('data-state');
    }
  }

  function submitQuickOrder(scope, pairs, trigger) {
    if (!pairs.length) {
      feedback(scope, STRINGS.empty_quick, 'error');
      return;
    }
    setBusy(trigger, true);
    feedback(scope, STRINGS.loading, null);

    Promise.all(pairs.map(function (p) {
      return resolveSku(p.sku).then(function (id) {
        return { id: id, quantity: p.quantity, sku: p.sku };
      });
    })).then(function (resolved) {
      var items = [];
      var missing = [];
      resolved.forEach(function (r) {
        if (r.id) {
          items.push({ id: r.id, quantity: r.quantity });
        } else {
          missing.push(r.sku);
        }
      });

      if (!items.length) {
        feedback(scope, format(STRINGS.not_found, { skus: missing.join(', ') }), 'error');
        setBusy(trigger, false);
        return;
      }

      addItems(items)
        .then(function () { return refreshCount(); })
        .then(function () {
          var count = items.reduce(function (sum, it) { return sum + it.quantity; }, 0);
          var msg = format(STRINGS.added_quick, { count: count });
          if (missing.length) {
            msg += ' · ' + format(STRINGS.not_found, { skus: missing.join(', ') });
          }
          feedback(scope, msg, missing.length ? 'error' : 'success');
          toast(format(STRINGS.added_quick, { count: count }));
        })
        .catch(function (err) {
          feedback(scope, (err && err.description) || STRINGS.error, 'error');
        })
        .finally(function () {
          setBusy(trigger, false);
        });
    });
  }

  document.addEventListener('click', function (event) {
    var submitBtn = event.target.closest('[data-quick-order-submit]');
    if (submitBtn) {
      var scope = submitBtn.closest('[data-quick-order]');
      if (!scope) return;
      event.preventDefault();
      submitQuickOrder(scope, readRows(scope), submitBtn);
      return;
    }

    var csvBtn = event.target.closest('[data-quick-order-csv]');
    if (csvBtn) {
      var csvScope = csvBtn.closest('[data-quick-order]');
      var fileInput = csvScope && csvScope.querySelector('[data-quick-order-file]');
      if (fileInput) {
        event.preventDefault();
        fileInput.click();
      }
    }
  });

  // CSV upload stub: parses "sku,qty" lines and adds them via the same flow.
  document.addEventListener('change', function (event) {
    var fileInput = event.target.closest('[data-quick-order-file]');
    if (!fileInput || !fileInput.files || !fileInput.files[0]) return;
    var scope = fileInput.closest('[data-quick-order]');
    var reader = new FileReader();
    reader.onload = function () {
      var pairs = String(reader.result || '')
        .split(/\r?\n/)
        .map(function (line) { return line.split(/[,;\t]/); })
        .filter(function (cols) { return cols[0] && cols[0].trim(); })
        .map(function (cols) {
          var qty = parseInt(cols[1], 10);
          return { sku: cols[0].trim(), quantity: qty && qty > 0 ? qty : 1 };
        })
        // Skip a header row like "sku,qty" / "artikelnummer,menge".
        .filter(function (p) { return !/^(sku|art|artikel)/i.test(p.sku) || /\d/.test(p.sku); });
      submitQuickOrder(scope, pairs, scope.querySelector('[data-quick-order-csv]'));
      fileInput.value = '';
    };
    reader.readAsText(fileInput.files[0]);
  });
})();
